import Config from './../../config/config';
import { IFacebookGraphResponse } from './models/IFacebookResponse';
import { RegisterPermissions } from './models/RegisterPermissions';

const fbDataRequestString = 'email,name,first_name,middle_name,last_name';

declare const window: Window & { fbAsyncInit: Function };

export class FacebookService {
    private static _isInitialized = false;
    private static _isSDKLoaded = false;
    private static _pendingOperations: Array<() => void> = [];

    public static init() {
        if (this._isInitialized) return;

        const scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.crossOrigin = 'anonymous';
        scriptTag.src = 'https://connect.facebook.net/de_DE/sdk.js';

        window.fbAsyncInit = () => {
            FB.init({
                appId: Config.FACEBOOK_APP_ID,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v9.0',
            });
            this._isSDKLoaded = true;
            this._executePendingOperations();
        };

        document.body.appendChild(scriptTag);
        this._isInitialized = true;
    }

    private static _executePendingOperations() {
        while (this._pendingOperations.length > 0) {
            const op = this._pendingOperations.shift();
            op?.();
        }
    }

    private static _ensureSDKLoaded(op: () => void) {
        if (!this._isInitialized) this.init();
        if (this._isSDKLoaded) op();
        else this._pendingOperations.push(op);
    }

    public static login(onLogin: (response: fb.StatusResponse) => Promise<void>, permissions: string[] = RegisterPermissions) {
        this._ensureSDKLoaded(() => {
            FB.login(
                (response) => void onLogin(response),
                { scope: permissions.join(','), return_scopes: true }
            );
        });
    }

    public static getUserData(_: string, onResponse: (err: object, result: IFacebookGraphResponse) => void) {
        this._ensureSDKLoaded(() => {
            FB.api('/me?fields=' + fbDataRequestString, (res: IFacebookGraphResponse) => {
                onResponse({}, res);
            });
        });
    }

    public static logout() {
        this._ensureSDKLoaded(() => {
            FB.getLoginStatus((res) => {
                if (res.status === 'connected') {
                    FB.logout();
                }
            });
        });
    }
}

export default FacebookService;
